<template lang="html">
<div>
    <!-- Temp messages -->
    <div class="cursor-pointer w-full lg:w-96 px-2 py-2 fixed sm:hidden lg:block left-0 lg:left-auto right-0 bottom-32 md:bottom-24 lg:bottom-16 transition-all duration-200"
         @click="showChat = !showChat" style="z-index: 50;" v-show="tempMessages.length > 0">
        <div class="space-y-4">
            <div class="w-full bg-white dark:bg-gray-800 shadow-md border py-4 px-4 flex space-x-4"
                 :class="dClass"
                 v-for="message in tempMessages" @click="message.timeout = 0">
                <div class="items-center space-x-2 hidden">
                    <div class="h-10 w-10 bg-gray-200 rounded-full"></div>
                </div>
                <div>
                    <p class="font-bold"> {{ message.name || "Somebody"}} </p>
                    <p> {{ message.body }} </p>
                </div>
            </div>
        </div>
    </div>

    <!-- Chat Header -->
    <div class="cursor-pointer font-bold text-base bg-white sm:w-64 w-24 dark:bg-gray-700 px-2 py-2 fixed z-30 ml-0 mr-0 lg:ml-32 lg:mr-32 border-2 transition-all duration-200 flex lg:flex justify-between items-center"
         :class="[{'mb-80 md:mb-56 bottom-40 border-gray-200 dark:border-gray-700': showChat && !isMobileLandscape, 'mb-0 bottom-48': showChat && isMobileLandscape, 'bottom-0': !showChat && isMobileLandscape, 'bottom-0 lg:bottom-0 border-gray-700 dark:border-gray-300': !showChat && !isMobileLandscape}, dClass]" 
         @click="showChat = !showChat" style="z-index: 60;">
        <div class="flex space-x-2">
            <!-- Chat icon -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 text-blue-600">
                <path fill-rule="evenodd" d="M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 01-3.476.383.39.39 0 00-.297.17l-2.755 4.133a.75.75 0 01-1.248 0l-2.755-4.133a.39.39 0 00-.297-.17 48.9 48.9 0 01-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97zM6.75 8.25a.75.75 0 01.75-.75h9a.75.75 0 010 1.5h-9a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H7.5z" clip-rule="evenodd" />
            </svg>

            <div> {{capitalize(idPrefix)}} Chat </div>
        </div>
        <!-- minus icon -->
        <svg class="block h-5 w-5 fill-current text-gray-400" v-show="showChat" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M16 10c0 .553-.048 1-.601 1H4.601C4.049 11 4 10.553 4 10c0-.553.049-1 .601-1H15.4c.552 0 .6.447.6 1z"/></svg>
        <div v-show="!showChat && unreadMessagesCount > 0" class="bg-blue-100 text-blue-500 p-2 rounded-full">{{unreadMessagesCount}}</div>
    </div>
    <transition
            enter-active-class="ease-out"
            enter-class="opacity-0 scale-y-0"
            enter-to-class="opacity-100 scale-y-100"
           leave-active-class="ease-in"
           leave-class="opacity-100 scale-y-100"
           leave-to-class="opacity-0 scale-y-0">
            <div class="flex lg:flex flex-wrap w-full lg:w-64 p-2 ml-0 lg:ml-32 mr-0 lg:mr-32 fixed z-50 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-800 shadow-lg transition duration-200 transform origin-bottom"
             :class="[{'bottom-0 h-48': isMobileLandscape, 'bottom-24 sm:bottom-0 lg:bottom-0': !isMobileLandscape}, dClass]" v-show="showChat">
                <div class="w-full relative h-full" :id="idPrefix + 'Chat'">
                    <!-- Unread messages banner -->
                        <button v-show="unreadMessagesCount > 0" class="absolute bottom-0 bg-blue-100 hover:bg-blue-300 text-blue-800 flex items-center inset-x-0 py-1 px-2 text-center mb-10" @click="scrollToLastMessage()">
                            <div>
                                <!-- Chevron down hero icons -->
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                </svg>
                            </div>
                            <div>Unread messages </div>
                        </button>
                    <div class="messages px-1 overflow-y-scroll h-80 mb-12 pb-20">
                    <div class="text-sm" v-for="message in chats.GLOBAL">
                        <div class="mt-2 text-sm" v-if="message.message">
                            <div class="flex justify-between">
                                <div class="text-xs font-bold " > {{ message.name || "Someone" }} </div>
                                <div class="text-xs text-gray-700 dark:text-gray-400">{{ timeHHMM(message.sent_at) }} </div>
                            </div>
                            <div class='bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded-sm inline-block' v-html="message.message"></div>
                        </div>
                    </div>

                    </div>
                    <form :id="idPrefix + 'ChatForm'" class="flex w-full absolute bottom-0" :class="dClass">
                        <textarea class="form-input w-2/3" :id="idPrefix +'chatMessage'" autocomplete='off'></textarea>
                        <button class="btn btn-primary w-1/3">Send</button>
                    </form>
                </div>
            </div>
        </transition>
        <audio class="soundBar" src="/audio/new_chat_message.mp3" :id="idPrefix+'newChatSound'"></audio>
        <audio class="soundBar" src="/audio/send_chat_message.mp3" :id="idPrefix + 'sendChatSound'"></audio>
    </div>
</template>
<script>
import { replaceLinksWithTags, timeHHMM } from 'general/util';
import messageBroker from 'general/messageBroker';
import hooksManager from 'general/HooksManager';

export default {
    props:{
        idPrefix: {
            type: String,
            required: false,
            default: ''
        },
        dClass: {
            type: String,
            required: false,
            default: 'right-0'
        }
    },
    data() {
        return {
            showChat: false,
            messages: [],
            tempMessages: [],
            unreadMessagesCount: 0,
            chats: { GLOBAL: [] },
            isMobileLandscape: false,
        }
    },
    mounted() {
        this.setupChat();
        messageBroker
        .registerNewMessageType(this.idPrefix + 'chat_message', this.handleChatMessage);

      hooksManager.registerNewHook("chat--open-chat", "chat--new-message", () => {
        this.showChat = true;
      });

      // Check if the scroll is at the end 
        $('#'+ this.idPrefix+ 'Chat .messages').scroll(() => {
            const { scrollHeight, scrollTop, clientHeight } = $('#'+ this.idPrefix+ 'Chat .messages')[0];
            if (scrollHeight - scrollTop === clientHeight) {
                this.unreadMessagesCount = 0;
            }
        });

        // check if textarea needs to be resized
        if ($('#'+ this.idPrefix+ 'chatMessage').length > 0) {
            $('#'+ this.idPrefix+ 'chatMessage').on('input', function () {
                this.style.height = 'auto';
                this.style.height = (this.scrollHeight) + 'px';
            });

            // listen to an "enter" keypress and send the message
            $('#'+ this.idPrefix+ 'chatMessage').on('keydown', (e) => {
                if (e.keyCode === 13 && !e.shiftKey) {
                    e.preventDefault();
                    this.composeMessage();
                }
            // if the user presses shift+enter, add a new line
                if (e.keyCode === 13 && e.shiftKey) {
                    e.preventDefault();
                    e.target.value += '\r\n';
                }
            });
        }

        this.isMobileLandscape = window.innerWidth < 1024 && window.innerWidth > window.innerHeight;
        // on resize check if the device is mobile landscape
        window.addEventListener('resize', () => {
            this.isMobileLandscape = window.innerWidth < 1024 && window.innerWidth > window.innerHeight;
        });

      // clean messages
      window.setInterval(() => {
        var aux = []
        for(var i = 0; i < this.tempMessages.length; i++){
          if (this.tempMessages[i].timeout > Date.now()){
            aux.push(this.tempMessages[i])
          }
        }
        this.tempMessages = aux;
      }, 1000)

    },
    methods: {
        timeHHMM(data){
            return timeHHMM(data)
        },
        setupChat() {
            $('#'+ this.idPrefix+ 'ChatForm').on('submit', (e) => {
                e.preventDefault();
                this.composeMessage();
            });
        },
        composeMessage() {
            let messageText = $('#'+ this.idPrefix+ 'chatMessage').val();
            if (messageText == null || messageText === '') return;
            let message = {
              body: messageText,
              sender_name: name,
            }

            this.sendChatMessage('GLOBAL', message); // sending chat to everyone in the room
            // update UI
            message.sender_name = "Me"
            const data = {
                message,
                sent_at: new Date(),
            };
            message = this.createMessageFromData(data);
            this.appendMessageToChat(message, false);
            this.scrollToLastMessage();
            $('#'+ this.idPrefix+ 'chatMessage').val('');
            // resize back down the textarea
            $('#'+ this.idPrefix+ 'chatMessage').css('height', '2.5rem');
            // focus again the textarea
            $('#'+ this.idPrefix+ 'chatMessage').focus();
        },
        sendChatMessage(to, message) {
            // send message through
            if (to == 'GLOBAL') messageBroker.sendMessage(message, this.idPrefix + 'chat_message');
            else messageBroker.sendMessage(message, this.idPrefix + 'chat_message', to);
            $('#'+ this.idPrefix+ "sendChatSound")[0].play()
        },
        handleChatMessage(data) {
            const message = this.createMessageFromData(data);

            // if its hidden show a notif-banner like message
            if (this.showChat == false) {
                this.tempMessages.push({
                    name: message.name,
                    body: message.message,
                    timeout: Date.now() + 5 * 1000
                })
            }
            this.appendMessageToChat(message, true);
            $('#' + this.idPrefix + "newChatSound")[0].play()
            hooksManager.emit("chat--new-message")

        },
        createMessageFromData(data) {
            return {
                name: data.message.sender_name,
                message: data.message.body,
                sent_at: new Date(),
            };
        },
        scrollToLastMessage() {
            const { scrollHeight } = $('#'+ this.idPrefix+ 'Chat .messages')[0];
            $('#'+ this.idPrefix+ 'Chat .messages').animate({ scrollTop: scrollHeight }, 'slow');
            this.unreadMessagesCount = 0;
        },
        appendMessageToChat(message, isRemote) {
            // Disabling replaceLinksWithTags as it doesnt work well witht the wbr routine below

            // message = replaceLinksWithTags(message);
            // if any word in the message is larger than 30 characters split it into two
            message.message = message.message.split(' ').map((word) => {
                if (word.length > 30) {
                    return word.replace(/(.{30})/g, '$1<wbr>');
                }
                return word;
            }).join(' ');
            this.chats['GLOBAL'].push(message); // save message in the dictionary
            this.incrementUnreadMessages();
            if (message.type == 'private') {
                // add to UI
                console.error("Not handling properly DMs")
                $(`#chat_${message.from} .messages`).append(message);
            } else {
            }
        },
        incrementUnreadMessages(){
            this.unreadMessagesCount += 1;
        },
    },
    watch: {
        showChat: function(newValue){
            if(newValue){
              this.tempMessages = []
                this.unreadMessagesCount = 0;
            }
        }
    }
}
</script>
<style lang="">

</style>
